import { createApi } from "@reduxjs/toolkit/query/react";
import { application } from "globals/endpoints";
import { telemetry } from "globals/endpoints";

export const geofenceApi = createApi({
  reducerPath: "geofenceApi",
  baseQuery: async (args) => {
    try {
      if (typeof args == "string") {
        const result =
          args?.url === "configJson/getGeometryData" ||
          args?.url === "configJson/saveGeometryData" ||
          args?.url === "user/list" ||
          args?.url === "userGroupMaster/listAll" ||
          args?.url === "uc/phoneBook/listByDepartment" ||
          args?.url === "userShift/unAssignZone" ||
          args?.url === "userShift/unAssignRoute" ||
          args?.url.substring(0, 14) === "userShift/user" ||
          args?.url.substring(0, 15) === "user/removeArea" ||
          args.url === "routeCoordinate/list" ||
          args?.url === "userCoordinate/listAll" ||
          args?.url === "userShift/update"
            ? await application(args)
            : await telemetry(args);
        return result;
      } else {
        const { url, method, body } = args;
        const result =
          args?.url === "configJson/getGeometryData" ||
          args?.url === "configJson/saveGeometryData" ||
          args?.url === "user/list" ||
          args?.url === "userGroupMaster/listAll" ||
          args?.url === "uc/phoneBook/listByDepartment" ||
          args?.url === "userShift/unAssignZone" ||
          args?.url === "userShift/unAssignRoute" ||
          args?.url.substring(0, 14) === "userShift/user" ||
          args?.url === "routeCoordinate/list" ||
          args?.url === "userCoordinate/listAll" ||
          args?.url === "userShift/update" ||
          args?.url.substring(0, 15) === "user/removeArea"
            ? await application({ url, method, data: body })
            : await telemetry({ url, method, data: body });
        return result;
      }
    } catch (axiosError) {
      return { error: axiosError.response?.data || axiosError.message };
    }
  },
  tagTypes: ["fenceRefetch", "geofenceRefetch"],
  endpoints: (builder) => ({
    createGeofence: builder.mutation({
      query: (payload) => ({
        url: "geofence/create",
        method: "POST",
        body: payload,
      }),
      transformResponse: (res) => res.data,
      invalidatesTags: ["geofenceRefetch"],
    }),
    updateGeofence: builder.mutation({
      query: (payload) => ({
        url: "geofence/update",
        method: "POST",
        body: payload,
      }),
      transformResponse: (res) => res.data,
      invalidatesTags: ["geofenceRefetch"],
    }),
    deleteGeofence: builder.mutation({
      query: (payload) => ({
        url: "geofence/delete",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["geofenceRefetch"],
    }),
    getAllGeofences: builder.query({
      query: () => ({
        url: "geofence/listAll",
        method: "POST",
      }),
      transformResponse: (res) => res.data,
      providesTags: ["geofenceRefetch"],
    }),
    getAllUserGroups: builder.mutation({
      query: () => ({
        url: "userGroupMaster/listAll",
        method: "POST",
      }),
    }),
    getPhoneBookByDepartment: builder.mutation({
      query: (payload) => ({
        url: "uc/phoneBook/listByDepartment",
        method: "POST",
        body: payload,
      }),
      transformResponse: (res) => res.data,
    }),
    getGeometryData: builder.query({
      query: () => ({
        url: "configJson/getGeometryData",
        method: "GET",
      }),
      transformResponse: (res) => res.data.data,
      providesTags: ["fenceRefetch"],
    }),
    getAllPolygonData: builder.query({
      query: () => ({
        url: "area/listAll",
        method: "GET",
      }),
      transformResponse: (res) => res,
      providesTags: ["fenceRefetch"],
    }),
    getAllRouteData: builder.query({
      query: () => ({
        url: "route/listAll",
        method: "GET",
      }),
      transformResponse: (res) => res,
      providesTags: ["fenceRefetch"],
    }),
    getUserLiveCoordinates: builder.query({
      query: () => ({
        url: "userCoordinate/listAll",
        method: "GET",
      }),
      transformResponse: (res) => res,
    }),
    updateGeometryData: builder.mutation({
      query: (payload) => ({
        url: "configJson/saveGeometryData",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["fenceRefetch"],
    }),
    createPolygon: builder.mutation({
      query: (payload) => ({
        url: "area/create",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["fenceRefetch"],
    }),
    updatePolygon: builder.mutation({
      query: (payload) => ({
        url: "area/update",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["fenceRefetch"],
    }),
    getAllPolygon: builder.mutation({
      query: (payload) => ({
        url: "area/listAll",
        method: "POST",
        body: payload,
      }),

      invalidatesTags: ["fenceRefetch"],
    }),
    getAllPolygonUsers: builder.mutation({
      query: (shapeId) => ({
        url: `area/listOfUserByShapeId/${shapeId}`,
        method: "POST",
      }),
      transformResponse: (res) => res.data,
    }),
    createRoute: builder.mutation({
      query: (payload) => ({
        url: "route/create",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["fenceRefetch"],
    }),
    updateRoute: builder.mutation({
      query: (payload) => ({
        url: "route/update",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["fenceRefetch"],
    }),
    getAllRoute: builder.mutation({
      query: (payload) => ({
        url: "route/listAll",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["fenceRefetch"],
    }),
    getAllUser: builder.mutation({
      query: (payload) => ({
        url: "user/list",
        method: "POST",
        body: payload,
      }),
    }),
    deletePolygon: builder.mutation({
      query: (payload) => ({
        url: "/area/delete/shapeId",
        method: "POST",
        body: payload,
      }),
    }),
    deleteRoute: builder.mutation({
      query: (payload) => ({
        url: "/route/delete/shapeId",
        method: "POST",
        body: payload,
      }),
    }),
    assignUserToRouteAndZone: builder.mutation({
      query: (payload) => ({
        url: "user/multiUpdate/user",
        method: "POST",
        body: payload,
      }),
    }),
    assignUserToRoute: builder.mutation({
      query: (payload) => ({
        url: "userShift/update",
        method: "POST",
        body: payload,
      }),
    }),
    getUserShiftDetails: builder.mutation({
      query: (userName) => ({
        url: `userShift/user/${userName}`,
        method: "POST",
      }),
    }),
    getRouteCoordinateList: builder.mutation({
      query: (payload) => ({
        url: "routeCoordinate/list",
        method: "POST",
        body: payload,
      }),
      transformResponse: (res) => res.data,
    }),
    getUserShiftDetailsAndRouteZones: builder.mutation({
      query: (userName) => ({
        url: `routeCoordinate/user/${userName}`,
        method: "POST",
      }),
    }),
    unAssignUserFromZone: builder.mutation({
      query: (payload) => ({
        url: "userShift/unAssignZone",
        body: payload,
        method: "POST",
      }),
    }),
    unAssignUserFromRoute: builder.mutation({
      query: (payload) => ({
        url: "userShift/unAssignRoute",
        body: payload,
        method: "POST",
      }),
    }),
  }),
});

export const {
  useCreateGeofenceMutation,
  useUpdateGeofenceMutation,
  useDeleteGeofenceMutation,
  useGetAllGeofencesQuery,
  useGetAllUserGroupsMutation,
  useGetPhoneBookByDepartmentMutation,
  useGetGeometryDataQuery,
  useGetAllPolygonDataQuery,
  useGetAllRouteDataQuery,
  useUpdateGeometryDataMutation,
  useGetUserLiveCoordinatesQuery,
  useCreatePolygonMutation,
  useUpdatePolygonMutation,
  useGetAllPolygonMutation,
  useGetAllPolygonUsersMutation,
  useCreateRouteMutation,
  useUpdateRouteMutation,
  useGetAllRouteMutation,
  useGetAllUserMutation,
  useDeletePolygonMutation,
  useDeleteRouteMutation,
  useAssignUserToRouteAndZoneMutation,
  useAssignUserToRouteMutation,
  useGetUserShiftDetailsMutation,
  useGetRouteCoordinateListMutation,
  useGetUserShiftDetailsAndRouteZonesMutation,
  useUnAssignUserFromZoneMutation,
  useUnAssignUserFromRouteMutation,
} = geofenceApi;
